// Global step multiplier for all steppers, like the game's buy-multiplier toggle.
import { createContext, useContext, useState, type ReactNode } from "react";

export const STEPS = [1, 10, 100] as const;
export type Step = (typeof STEPS)[number];

const StepContext = createContext<{ step: Step; cycle: () => void }>({
  step: 1,
  cycle: () => {},
});

export function StepProvider({ children }: { children: ReactNode }) {
  const [step, setStep] = useState<Step>(1);
  const cycle = () =>
    setStep((s) => STEPS[(STEPS.indexOf(s) + 1) % STEPS.length]);
  return <StepContext.Provider value={{ step, cycle }}>{children}</StepContext.Provider>;
}

export function useStep() {
  return useContext(StepContext);
}

export function StepToggle() {
  const { step, cycle } = useStep();
  return (
    <button className="step-toggle" onClick={cycle} title="Step size for +/- buttons">
      ×{step}
    </button>
  );
}
